<div class="acs-page">

  <!-- Loading State -->
  <div *ngIf="isLoading" class="acs-page__loading">
    <acs-loading-spinner size="large" message="Loading users..." />
  </div>

  <!-- Error State -->
  <acs-alert
    *ngIf="error"
    type="error"
    title="Error Loading Users"
    [message]="error"
    [dismissible]="true"
    (dismissed)="error = null">
  </acs-alert>

  <!-- Main Content -->
  <div *ngIf="!isLoading" class="acs-page__content">

    <!-- Header Section -->
    <div class="acs-page-header">
      <div class="acs-page-header__title-section">
        <h1 class="acs-page-header__title">System Users</h1>
        <p class="acs-page-header__subtitle">
          Manage and monitor all system users. Impersonate users for support and troubleshooting purposes.
          <span class="acs-page-header__role" *ngIf="currentUser.FirstLast">Current user: {{ currentUser.FirstLast }}</span>
        </p>
      </div>
    </div>

    <!-- Users Data Grid Section -->
    <div class="acs-grid-section">
      <div class="acs-grid-section__header">
        <h2 class="acs-grid-section__title">User Directory</h2>
        <p class="acs-grid-section__description">
          Complete directory of all system users with impersonation capabilities for administrative support.
        </p>
        <p class="acs-grid-section__description">
          Use the impersonate action to temporarily access a user's account for support purposes. All impersonation sessions are logged for security.
        </p>
      </div>

      <div class="acs-grid-section__container">
        <acs-data-grid
          #usersGrid
          [data]="tableData"
          [columns]="gridColumns"
          [selectable]="'single'"
          [pageSize]="25"
          [sortable]="true"
          [filterable]="true"
          [searchable]="true"
          [showPagination]="true"
          [virtualScrolling]="false"
          [stickyHeader]="true"
          emptyText="No users found"
          searchPlaceholder="Search users...">
        </acs-data-grid>
      </div>
    </div>

  </div>

  <!-- Impersonation Confirmation Modal -->
  <acs-modal 
    *ngIf="showImpersonationModal"
    [title]="'Confirm User Impersonation'"
    [isOpen]="showImpersonationModal"
    [size]="'medium'"
    (closed)="closeImpersonationModal()">
    
    <div class="impersonation-form" *ngIf="impersonationTarget">
      <div class="warning-section">
        <div class="warning-header">
          <span class="warning-icon">⚠️</span>
          <strong>Important Security Notice</strong>
        </div>
        <p class="warning-text">
          You are about to impersonate <strong>{{ impersonationTarget.Name }}</strong>. 
          This will give you full access to their account and permissions. This action will be logged for security purposes.
        </p>
      </div>

      <div class="target-user-info">
        <h4>Target User Details</h4>
        <div class="user-details">
          <div class="detail-row">
            <span class="label">Name:</span>
            <span class="value">{{ impersonationTarget.Name }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Email:</span>
            <span class="value">{{ impersonationTarget.Email }}</span>
          </div>
        </div>
      </div>

      <!-- Reason Input -->
      <div class="form-row">
        <label for="impersonationReason">Reason for Impersonation</label>
        <textarea 
          id="impersonationReason"
          [(ngModel)]="impersonationReason"
          placeholder="Optional: Provide a reason for impersonating this user (e.g., troubleshooting, support)"
          rows="3"
          maxlength="500">
        </textarea>
        <div class="form-text">{{ impersonationReason.length }}/500 characters</div>
      </div>

      <!-- Duration Selection -->
      <div class="form-row">
        <label for="impersonationDuration">Session Duration (minutes)</label>
        <select 
          id="impersonationDuration"
          [(ngModel)]="impersonationDuration">
          <option value="15">15 minutes</option>
          <option value="30">30 minutes</option>
          <option value="60">1 hour</option>
          <option value="120">2 hours</option>
          <option value="240">4 hours</option>
        </select>
        <div class="form-text">Session will automatically expire after the selected duration</div>
      </div>

      <!-- Modal Actions -->
      <div class="modal-actions">
        <acs-button 
          variant="secondary"
          (click)="closeImpersonationModal()"
          [disabled]="isStartingImpersonation">
          Cancel
        </acs-button>
        <acs-button 
          variant="primary"
          (click)="startImpersonation()"
          [disabled]="isStartingImpersonation">
          <span *ngIf="isStartingImpersonation">Starting...</span>
          <span *ngIf="!isStartingImpersonation">Start Impersonation</span>
        </acs-button>
      </div>
    </div>
  </acs-modal>
</div>